import React, { useState } from 'react';
import { useForm } from '@mantine/form';
import { TextInput, Button, Group, NumberInput } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { IconCheck } from '@tabler/icons-react';
import { saveBenefitCode } from '../../services/api.service';

const BenefitCodeForm = ({ benefit, reload }) => {

	// Hooks
	const [isLoading, toggleLoading] = useState(false);
	const form = useForm({
		initialValues: {
			benefit: {
				id: benefit,
			},
			code: '',
			stock: 0,
			available: 0,
		},
	});

	// Submit form
	const onSubmit = (values) => {

		// Set loader
		toggleLoading(true);

		// Call API
		saveBenefitCode(values, function () {

			// Show success
			notifications.show({
				title: 'Nivel de beneficio creado correctamente',
				color: 'green',
				icon: <IconCheck />
			});

			// Reload after 1 second
			setTimeout(() => {

				// Remove loader
				toggleLoading(false);

				// Reload list
				reload();

			}, 1000);

		}, function (error) {

			// Remove preloader
			toggleLoading(false);

			// Show error
			notifications.show({
				title: 'Error',
				message: error,
				color: 'red'
			});

		});

	}

	return (
		<>
			{/* Form */}
			<form onSubmit={form.onSubmit(onSubmit)}>
				{/* Input Group */}
				<Group grow>
					{/* Code */}
					<TextInput
						required
						label="Código"
						placeholder="Código"
						value={form.values.code}
						onChange={(event) => form.setFieldValue('code', event.currentTarget.value)}
						{...form.getInputProps('code')}
					/>
				</Group>
				<Group
					grow
					mt="md"
				>
					{/* Stock */}
					<NumberInput
						required
						label="Inventario"
						placeholder="Inventario"
						value={form.values.stock}
						onChange={(event) => form.setFieldValue('stock', event.currentTarget.value)}
						{...form.getInputProps('stock')}
						min={0}
						step={1}
					/>
					{/* Available */}
					<NumberInput
						required
						label="Disponible"
						placeholder="Disponible"
						value={form.values.available}
						onChange={(event) => form.setFieldValue('available', event.currentTarget.value)}
						{...form.getInputProps('available')}
						min={0}
						step={1}
					/>
				</Group>
				{/* Buttons */}
				<Group position="apart">
					{/* Submit */}
					<Button
						mt="xl"
						type="submit"
						loading={isLoading}
						variant="filled"
						sx={{ flexGrow: 1 }}
					>
						Guardar Código
					</Button>
				</Group>
			</form>
		</>
	);

}

export default BenefitCodeForm;
